module.exports = __webpack_public_path__ + "media/images/turbochargers/KKK-ef814218b50614c1de3e9a637462c7d7.jpg";